export default {
  wrapper: {
    lineHeight: 1.35,
  },
};
